import { useFormatter, useTranslations } from 'next-intl';
import { scaleBytes } from 'utils/FileUtils';

export type FormattedSize = { value: string; unit: string };

// A file size in the page language, e.g. "1.5 MB" or "1,5 Mo". The number
// and the unit come back separately, so a screen can style them apart.
export const useFormatBytes = () => {
  const t = useTranslations();
  const format = useFormatter();

  return (bytes: number): FormattedSize => {
    const { amount, unit } = scaleBytes(bytes);
    return {
      value: format.number(amount, { maximumFractionDigits: 1 }),
      unit: t(`fileSize.${unit}`),
    };
  };
};
